module.exports = __webpack_public_path__ + "src/asset/svg/bookmark/artist.svg?4bd7055ca81926c4158e072560566551";


//////////////////
// WEBPACK FOOTER
// ./src/asset/svg/bookmark/artist.svg
// module id = 12
// module chunks = 0